export interface DanfeState {
  invoiceHtml: string;
  loading: boolean;
}

export enum InvoiceTypes {
  RECEIVEMENT= 'receivement',
  RETURN= 'return'
}

export interface GetInvoiceParams {
  invoiceKey: string;
  type: InvoiceTypes;
  onError?: () => void
}
